import { useEffect, useContext, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";


import classes from "../Brand/Brand.module.css";
import { getUsers, deleteUser, updateUserStatus } from "../../../redux/actions/userActions";
import Table, {
  StyledTableCell,
  StyledTableRow,
} from "../../../Component/UI/Table/Table";
import MUIIconButton from "./../../../Component/UI/MUIIconButton/MUIIconButton";
import { AuthContext } from "../../../context/auth-context";
import Spinner from "./../../../Component/Spinner/Spinner";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import { ToastContainer } from "react-toastify";

const TABLE_HEADERS = [
  { id: "id", name: "Id", sorting: true },
  { id: "email", name: "Email", sorting: false },
  { id: "verified", name: "Verified", sorting: true },
  { id: "active", name: "Active", sorting: true },
  { id: "created", name: "Created at", sorting: true },
  { id: "actions", name: "Actions", sorting: false },
];

export default function Users() {
  const dispatch = useDispatch();

  const [confirmDelete, setConfirmDelete] = useState(null);

  const [confirmToggle, setConfirmToggle] = useState(null);

  const { users, deleteUserError, updateUserError, addUserError, isLoading } =
    useSelector((state) => state.user);

  const authCtx = useContext(AuthContext);

  useEffect(() => {
    dispatch(getUsers(authCtx?.user?.customer_id || -1));
  }, []);

  let errorMessage = null;
  if (deleteUserError) {
    errorMessage = `Failed to delete an user - ${deleteUserError}`;
  }
  if (updateUserError) {
    errorMessage = `Failed to update an user - ${updateUserError}`;
  }
  if (addUserError) {
    errorMessage = `Failed to add an user - ${addUserError}`;
  }
  const formatDate = (isoString) => {
    const date = new Date(isoString);

    // Format date as DD-MM-YYYY
    const formattedDate = date.toLocaleDateString("en-GB"); // en-GB provides DD-MM-YYYY format

    // Format time as 12-hour format with AM/PM
    const formattedTime = date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return `${formattedDate} ${formattedTime}`;
  };

  const handleDeleteClick = (item) => {
    console.log(item, "item");
    setConfirmDelete({
      id: item.id,
      email: item.email,
    });
  };

  const handleConfirmDelete = () => {
    if (confirmDelete) {
      dispatch(deleteUser(authCtx.user, confirmDelete.id));
    }
    setConfirmDelete(null);
  };

  const handleCancelDelete = () => {
    setConfirmDelete(null);
  };

  const handleToggleClick = (item) => {
    const nextStatus = item.is_active ? false : true;
    setConfirmToggle({
      id: item.id,
      email: item.email,
      currentStatus: !!item.is_active,
      nextStatus,
    });
  };

  const handleConfirmToggle = () => {
    if (confirmToggle) {
      dispatch(
        updateUserStatus(
          authCtx.user,
          confirmToggle.id,
          confirmToggle.nextStatus
        )
      );
    }
    setConfirmToggle(null);
  };

  const handleCancelToggle = () => {
    setConfirmToggle(null);
  };


  const renderRow = (item) => (
    <StyledTableRow key={item.id}>
      <StyledTableCell component="th" scope="row" style={{ width: 150 }}>
        {item.id}
      </StyledTableCell>
      <StyledTableCell component="th" scope="row" style={{ width: 300 }}>
        {item.email}
      </StyledTableCell>

      <StyledTableCell align="left" style={{ width: 200 }}>
        <div className={classes.status}>
          <CheckCircleIcon style={{ color: "#028101" }} />
          <span>{item.is_verified == true ? "Verified" : "Not Verified"}</span>
        </div>
      </StyledTableCell>

      {/* <StyledTableCell align="left" style={{ width: 200 }}>
        <div className={classes.status}>
          <CheckCircleIcon style={{ color: "#028101" }} />
          <span>{item.is_active == 1 ? "Active" : "Inactive"}</span>
        </div>
      </StyledTableCell> */}

      {/* ✅ Enable / Disable Toggle Column */}
      <StyledTableCell align="left" style={{ width: 200 }}>
        <div className={classes.status}>
          <MUIIconButton
            tooltip={item.is_active ? "Disable User" : "Enable User"}
            // onClick={() => handleToggleStatus(item)}
            onClick={() => handleToggleClick(item)}
            color={item.is_active ? "success" : "error"}
            style={{ padding: 0, marginRight: 4, top: "-4px" }}
          >
            {item.is_active ? (
              <ToggleOnIcon style={{ color: "#2e7d32", fontSize: 28 }} />
            ) : (
              <ToggleOffIcon style={{ color: "#d32f2f", fontSize: 28 }} />
            )}
          </MUIIconButton>
          <span>{item.is_active ? "Active" : "Inactive"}</span>
        </div>
      </StyledTableCell>

      <StyledTableCell align="left" style={{ width: 300 }}>
        {formatDate(item.date_added)}
      </StyledTableCell>
      <StyledTableCell align="left">
        <div>
          {/* <MUIIconButton
            tooltip="Update"
            style={{ color: "#007aff" }}
            className={classes.action_btn}
          >
            <EditIcon />
          </MUIIconButton> */}
          <MUIIconButton
            tooltip="Delete"
            style={{ color: "#da1a04" }}
            className={classes.action_btn}
            // onClick={() => {
            //   console.log(item, "item");
            //   deleteUserCreated(item);
            // }}
            onClick={() => handleDeleteClick(item)}
          >
            <DeleteOutlineIcon />
          </MUIIconButton>
        </div>
      </StyledTableCell>
    </StyledTableRow>
  );

  const deleteUserCreated = (item) => {
    dispatch(deleteUser(authCtx.user, item.id));
  };

  const handleToggleStatus = (item) => {
    const newStatus = item.is_active ? false : true;
    dispatch(
      updateUserStatus(authCtx.user, item.id, newStatus) // you’ll implement this API call in Redux
    );
  };

  return (
    <>
      {!isLoading && users.length > 0 && (
        <Table headers={TABLE_HEADERS} data={users} render={renderRow} />
      )}
      {isLoading && <Spinner />}
      {/* Delete confirmation dialog */}
      <Dialog
        open={!!confirmDelete}
        onClose={handleCancelDelete}
      >
        <DialogTitle>
          Delete User?
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {confirmDelete
              ? `Are you sure you want to delete user "${confirmDelete.email}"?`
              : ""}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete}>Cancel</Button>
          <Button
            onClick={handleConfirmDelete}
            color="error"
            variant="text"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Enable / Disable confirmation dialog */}
      <Dialog
        open={!!confirmToggle}
        onClose={handleCancelToggle}
      >
        <DialogTitle>
          {confirmToggle?.nextStatus ? "Activate User?" : "Deactivate User?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {confirmToggle
              ? `User "${confirmToggle.email}" will be marked as ${confirmToggle.nextStatus ? "Active" : "Inactive"
              } in the system.`
              : ""}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelToggle}>Cancel</Button>
          <Button
            onClick={handleConfirmToggle}
            variant="text"
            color={confirmToggle?.nextStatus ? "success" : "error"}
          >
            {/* {confirmToggle?.nextStatus ? "Active" : "Inactive"} */}
            {"Confirm"}
          </Button>
        </DialogActions>
      </Dialog>
      <ToastContainer />
    </>
  );
}
